



























import DashboardItem from '@/views/components/dashboard/dashboard-item.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
  components: {
    DashboardItem,
  },
})
export default class InstancesSurvey extends Vue {
  @State('rocketbot') private rocketGlobal: any;
  @State('rocketOption') private stateDashboardOption!: any;
  @State('rocketData') private rocketComps!: any;

  private dragIndex: number = NaN;


  public dragStart(index: number) {
    this.dragIndex = index;
  }
}
